import { useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";

import { PermissionBit, UserFeatureFlag } from "../api";
import { hasPermission } from "../constants/permissions";
import { AppModel } from "./app-model";
import { ErrorPage } from "./error-page";

export const RouteAccess = observer(function RouteAccess({
  app,
  permission,
  featureFlag,
  children,
}: {
  app: AppModel;
  /** A single bit, or a check for access that no one bit captures. */
  permission: PermissionBit | ((app: AppModel) => boolean);
  /**
   * Additionally require this per-user feature flag. A flag the API did not
   * send reads as off, so a route gated on one stays closed until the flag is
   * explicitly turned on for the user.
   */
  featureFlag?: UserFeatureFlag;
  children: ReactNode;
}) {
  const { t } = useLingui();
  const allowed =
    (typeof permission === "function"
      ? permission(app)
      : hasPermission(app.seerlinqApi.permissions, permission)) &&
    (featureFlag == null || app.seerlinqApi.hasFeatureFlag(featureFlag));
  if (!allowed) {
    return (
      <div className="flex h-full items-center justify-center flex-auto">
        <ErrorPage
          title={t`Access denied`}
          message={t`You don't have permission to access this section.`}
        />
      </div>
    );
  }

  return <>{children}</>;
});
